import type { FC } from "react";
import { useNavigate, useParams } from "react-router";
import { appPaths } from "../../../app/appPaths.js";
import { SignalEditorPage } from "./signalEditorPage.js";

/** The signal editor as a route element: closing returns to the signal list. */
export const SignalEditorRoute: FC = () => {
  const navigate = useNavigate();
  const { signalId } = useParams();
  const handleClose = () => navigate(appPaths.settingsSignals.build());

  return <SignalEditorPage key={signalId ?? "new"} onClose={handleClose} />;
};
